const Hub = (($) => {

    const subscribers = {};
    const methods = {
        subscribe: function (eventName, callback) {
            if (!Array.isArray(subscribers[eventName])) {
                subscribers[eventName] = []
            }
            subscribers[eventName].push(callback);
        },
        publish: function (eventName, data) {
            if (!Array.isArray(subscribers[eventName])) {
                return
            }
            subscribers[eventName].forEach((callback) => {
                callback(data)
            })
        }
    };

    const topics = {
        // Account
        ACCOUNT_LOGIN_SUCCESS: 'account.loginSuccess',
        ACCOUNT_SHOW_LOGIN: 'account.showLogin',
        // User
        USER_DATA_CHANGE: 'user.data.set',
        // Html
        HTML_UPDATE: 'html.update',
        // Product
        PRODUCT_VIEW: 'product.view',
        // Filter
        FILTER_OPEN: 'filter.open',
        // Portal
        PORTAL_OPEN: 'portal.open',
        PORTAL_CLOSE: 'portal.close',
        // Like
        LIKE_ADD: 'like.add',
        LIKE_REMOVE: 'like.remove',
        // Track
        TRACK_GRAFANA: 'tracking',
        // Drawer
        DRAWER_OPEN: 'drawer.open',
        DRAWER_CLOSE: 'drawer.close',
        //Router
        INIT_PAGE_HEAD_ROUTER: 'router.init.pageHead',
        INIT_FILTERS_ROUTER: 'router.init.filters'
    };

    return Object.assign(methods, topics);

})(window.jQuery);

export default Hub;
